import { observable, action, runInAction, computed } from 'mobx'
import { json } from '../../../../../utils/ajax'
import {message} from 'antd'

class ReceiverStore {
  @observable loading
  @observable forms
  @observable comments
  @observable id     //关联评论的id
  @observable receiverId
  @observable pagination
  @observable count
  @observable maxLength

  constructor () {
    this.loading = false
    this.forms = {}
    this.comments = []
    this.receiverId = ''
    this.pagination = {}
    this.maxLength = 5;
  }

  @action
  getMore = () =>{
    runInAction(()=>{
      this.maxLength +=5;
    })
  }
  @computed
  get fields () {
    let fields = {
      comments: {value: this.forms.comments},
    }
    return fields
  }

  @action.bound
  onEditFieldChange = (changedFields) => {
    const fields = {...this.fields, ...changedFields}
    let forms = {
      comments: fields.comments.value,
    }
    this.forms = forms
  }

  @action getComments = async (id,page,parentId) => {
    runInAction(() => {
      this.loading = true
      this.id = id;
    })
    if(!parentId){
      parentId = 0;
    }
    // 服务器page参数下标从0开始
    if (page) {
      page--
    } else if (this.pagination.page) {
      page = this.pagination.page - 1
    } else {
      page = 0
    }
    const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/comment/list:search?subjectId=`+id+`&parentId=`+parentId+`&page=`+page)
    if (res && res.status === 0) {
      return
    }
    runInAction(() => {
      this.comments = res.content;
      this.pagination = {
        total: res.totalElements,
        results: res.size,
        page: res.number + 1,
      }
      this.loading = false
    })
  }

  @action receiver = async (id) => {
    runInAction(()=>{
      this.maxLength = 5;
    })
    let list = this.comments.map(item => {
      if(item.commentId === id){
        item.checked = !item.checked
        item.children.maxLength = 5;
      }
      return item;
    });
    runInAction(()=>{
      this.comments = list;
      this.receiverId = id
    })
  }

  @action.bound receiverOne = (id) => {
    this.receiverId = id
  }

  @action submitEdit = async () => {
    runInAction(() => {
      this.loading = true
    })
    this.forms.subjectId = this.id;
    this.forms.parentId = '0';
    this.forms.receiver = '';
    const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/comment`,this.forms)
    if (res && res.status === 0) {
      return
    }
    runInAction(() => {
      this.loading = false;
      this.forms = {
        comments: ''
      }
    })
    message.success('评论成功！')
    await this.getComments(this.id);
  }
  @action submitReply = async (id,comments,receiver,sender) => {
    if(comments===''){
      message.warning('请输入回复！');
      return
    }
    runInAction(() => {
      this.loading = true
    })
    let forms= {
      sender: sender,
      subjectId: this.id,
      parentId: id,
      comments: comments,
      receiver: receiver,
    }
    const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/comment`,forms)
    if (res && res.status === 0) {
      return
    }
    for(let i = 0;i<this.comments.length;i++){
      if(this.comments[i].checked && this.comments[i].commentId === id){
        runInAction(() => {
          this.comments[i].children.push(res);
          this.maxLength = this.comments[i].children.length;
          this.loading = false;
        })
      }
    }
    runInAction(() => {
      this.loading = false;
    })
    message.success('回复成功！')
  }
}

export default new ReceiverStore()


// WEBPACK FOOTER //
// ./src/project/dongfeng/web/receiver/Receiver/store.js